import { render, staticRenderFns } from "./Book.vue?vue&type=template&id=9b94feac&scoped=true"
import script from "./Book.vue?vue&type=script&lang=ts"
export * from "./Book.vue?vue&type=script&lang=ts"
import style0 from "./Book.vue?vue&type=style&index=0&id=9b94feac&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b94feac",
  null
  
)

export default component.exports